import { AxiosResponse } from 'axios';
import { connect } from 'react-redux';
import { Book, EBook, Results } from '../../components';
import { NoResults } from '../../components/Results';
import { docUrl, ebookUrl } from '../../helpers';
import { Books } from '../../models';
import { Content } from '../../pages/Template';
import { setSearch } from '../../reducers/search/actions';
import { navigate } from '../../services';
import { AppState } from '../../store';
import { ItemProps } from '../FeaturedPage/Slider';
import React from 'react';

const mapStateToProps = ({ search }: AppState) => ({
    // @ts-ignore
    search: search.get('text') as string,
});
const mapDispatch = {
    setSearch,
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatch;
type OwnProps = {
    match: {
        params: {
            search: string;
        };
    };
};
type Props = OwnProps & StateProps & DispatchProps;

type Ebook = {
    id: number;
    title: string;
    total_pages: number;
};

type State = {
    list: ItemProps[];
    ebooks: Ebook[];
    stats: {
        offset: number;
        total: number;
    };
};

class SearchPage extends React.Component<Props, State> {
    static paths = ['/app/s/:search'];

    constructor(props: Props) {
        super(props);
        this.state = {
            list: [],
            ebooks: [],
            stats: {
                offset: 0,
                total: 0,
            },
        };
    }

    async componentDidMount() {
        await this.fetch(this.props.search);
        this.props.setSearch(this.props.match.params.search);
    }

    async componentDidUpdate(
        prevProps: Readonly<Props>,
        prevState: Readonly<State>,
        snapshot?: any
    ) {
        await this.fetch(this.props.search);
    }

    private loading = false;
    fetch = async (search: string) => {
        if (this.loading) {
            return;
        }
        this.loading = true;

        if (!search) {
            search = '';
            this.loading = false;
            return;
        }

        try {
            const params = [
                'includeMeta=true',
                'includesPages=true',
                `search=${search}`,
                `offset=0`,
            ];

            const {
                data: { search: searchQuery, list, ebooks, stats },
            }: AxiosResponse<{
                search: string;
                list: ItemProps[];
                ebooks: Ebook[];
                stats: {
                    offset: number;
                    total: number;
                };
            }> = await Books.list({
                url: params.join('&'),
            });
            console.log(
                'this.props.search',
                this.props.search,
                'searchQuery',
                searchQuery
            );
            this.setState({
                stats,
                ebooks,
                list,
            });
            this.loading = false;
        } catch (e) {
            console.warn(e);
        }
    };

    onMore = async () => {
        await this.fetch(this.props.search);
    };

    render() {
        const { list, ebooks, stats } = this.state;
        if (list.length === 0 && ebooks.length === 0) {
            return <NoResults message="results.none" />;
        }

        return (
            <Content>
                <Results stats={stats} onMore={this.onMore}>
                    <>
                        {list.map((item) => (
                            <Book
                                {...item}
                                width={220}
                                key={`book-${item.id}`}
                                onClick={() => navigate.to(docUrl(item))}
                            />
                        ))}
                        {ebooks.map((item) => (
                            <EBook
                                {...item}
                                width={220}
                                key={`ebook-${item.id}`}
                                onClick={() =>
                                    (window.location.href = ebookUrl(item))
                                }
                            />
                        ))}
                    </>
                </Results>
            </Content>
        );
    }
}

export default connect(mapStateToProps, mapDispatch)(SearchPage);
